function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  color: #6d747b;\n  font-size: 13px;\n  line-height: 23.25px;\n  margin-bottom: 12px;\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  b {\n    font-weight: bolder;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from 'styled-components';
import { maxWidth, lineHeight, textAlign, alignSelf, fontSize, space } from 'styled-system';
export default styled.p(_templateObject(), maxWidth, lineHeight, textAlign, alignSelf, fontSize, space);
